import { Injectable } from '@angular/core';
import { SolicitudAtencionRepository } from './solicitud-atencion.repository';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { adjArchivosExcepcionRquest, atencionClienteExcepcionRequest, confirmarRucAtencionClienteRequest, insertarEventosOvRequest, mantenimientoAtencionClienteRequest, obtieneDocumentosFacturaRequest, obtieneTicketAtencionRequest, obtieneTrackingTicketRequest, ocrSolicitudAtencionRequest } from '../domain/solicitud-atencion.request';
import { insertarEventosOvResponse, obtieneDocumentosFacturaResponse, obtieneTicketAtencionResponse, obtieneTrackingTicketResponse, ocrSolicitudAtencionResponse } from '../domain/solicitud-atencion.response';
import { generalTransaccionResponse } from 'src/app/shared/domain/shared.request';

@Injectable({
  providedIn: 'root'
})
export class SolicitudAtencionService extends SolicitudAtencionRepository {

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }

  override getServicesByFilter(request: obtieneDocumentosFacturaRequest): Observable<obtieneDocumentosFacturaResponse> {
    return this.http.post<obtieneDocumentosFacturaResponse>(`${environment.PATH_API}/extranet/getDocumentosFacturacionFilterByHBL`, request)
  }

  override mantenimientoAtencionCliente(request: mantenimientoAtencionClienteRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/extranet/manSolicitudTicket`, request)
  }

  override getTrackingByNroTicket(request: obtieneTrackingTicketRequest): Observable<obtieneTrackingTicketResponse> {
    return this.http.post<obtieneTrackingTicketResponse>(`${environment.PATH_API}/extranet/getTrackingByNroTicket`, request)
  }

  override getTicketGeneratedByUser(request: obtieneTicketAtencionRequest): Observable<obtieneTicketAtencionResponse> {
    return this.http.post<obtieneTicketAtencionResponse>(`${environment.PATH_API}/extranet/getTicketGeneratedByUser`, request)

  }

  override ocrSolicitudAtencion(request: ocrSolicitudAtencionRequest): Observable<ocrSolicitudAtencionResponse> {
    return this.http.post<ocrSolicitudAtencionResponse>(`${environment.PATH_API}/extranet/procesarVoucherOcrSolicitudAtencion`, request)
  }

  override insertarEventosOv(request: insertarEventosOvRequest): Observable<insertarEventosOvResponse> {
    return this.http.post<insertarEventosOvResponse>(`${environment.PATH_API}/extranet/insertarEventosOV`, request)
  }

  override confirmarRuc(request: confirmarRucAtencionClienteRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/extranet/actualizarRuc`, request)
  }

  override atencionClienteRegistroExcepcion(request: atencionClienteExcepcionRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/extranet/excepcionPago`, request)
  }

  override procesarAdjuntarArchivosExcepcion(request: adjArchivosExcepcionRquest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/extranet/archivosConExcepcionEXC`, request)
  }

}
